import { Component, OnInit } from '@angular/core';
import {ReceivedPoll} from '../models/ReceivedPoll';
import {ShortVoter} from '../models/ShortVoter';
import {ActivatedRoute, Router} from '@angular/router';
import {ApiService} from '../shared/api.service';
import {Common} from '../shared/common';
import {TimeDelta} from '../models/TimeDelta';
import { saveAs } from 'file-saver';

@Component({
  selector: 'app-poll-ongoing-assessor',
  templateUrl: './poll-ongoing-assessor.component.html',
  styleUrls: ['./poll-ongoing-assessor.component.less']
})
export class PollOngoingAssessorComponent implements OnInit {
  pollId: string;
  code: string;
  poll: ReceivedPoll;
  startDate: string;
  endDate: string;
  timeDifference = new TimeDelta(0, 0, 0, 0);
  answers: Array<any>;
  candidates: any;
  titles: Array<string> = [];
  lists = [];
  remainingVoters: Array<ShortVoter> = [];
  shouldDisplayVoters = false;
  isError = false;
  errorMessage: string;
  participation = '0';

  constructor(private route: ActivatedRoute,
              private apiService: ApiService,
              public common: Common,
              private router: Router) { }

  displayVoters() {
    this.apiService.getRemainingAssessorValidation(this.pollId, this.code).subscribe((res: Array<ShortVoter>) => {
      this.remainingVoters = res;
      this.shouldDisplayVoters = true;
    });
  }

  dismissVoters() {
    this.shouldDisplayVoters = false;
  }

  navigateHome() {
    this.router.navigate(['/']);
  }

  downloadVoterFile() {
    this.apiService.getVoterFileAssessor(this.pollId, this.code, this.common.getLangCode()).subscribe((res: any) => {
      const blob = new Blob([res], {type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet\n'});
      saveAs(blob, this.common.getVotersExcelName('xlsx', this.common.getLangCode()));
    });
  }

  ngOnInit(): void {
    const pollIdKey = 'id';
    const validationCodeId = 'code';
    this.pollId = this.route.snapshot.params[pollIdKey];
    this.code = this.route.snapshot.params[validationCodeId];
    this.apiService.getPollForAssessor(this.pollId, this.code).subscribe((res: ReceivedPoll) => {
      this.poll = res;
      this.startDate = new Date(res.startDate).toLocaleString();
      this.endDate = new Date(res.endDate).toLocaleString();
      if (res.type.localeCompare('resolution') === 0) {
        this.answers = res.rounds[0].displayedQuestions;
        this.lists = res.rounds;
      }
      if (res.type.localeCompare('election') === 0) {
        this.answers = res.rounds;
        if (res.rounds[0].displayedQuestions.length > 0) {
          this.answers = res.rounds;
          this.candidates = this.answers[0].displayedQuestions;
        }
      }
      if (res.type.localeCompare('list') === 0) {
        this.answers = res.rounds;
        this.lists = res.rounds;
        res.rounds.forEach(element => {
          this.titles.push(element.title);
        });
      }
      const percentage = (res.votes / res.voters) * 100;
      if (percentage === 100) {
        this.participation = percentage.toPrecision(3);
      }
      else {
        this.participation = percentage.toFixed(2);
      }
      setInterval(() => {
        const timerDiff = (new Date(res.endDate)).getTime() - (new Date()).getTime();
        this.timeDifference = this.common.getTimeDelta(timerDiff);
      }, 1000);
    }, (err: any) => {
      this.isError = true;
      this.errorMessage = 'Nous sommes désolés mais vous ne pouvez accéder au contenu \nerreur' + err.status;
    });
  }

}
